import { List, Datagrid, TextField } from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';

const OTPList = () => {
    return (
        <div>
            <List
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="countryCode" />
                    <TextField source="phone" />
                    <TextField source="otp" />
                    <TextField source="key" />
                    <FormattedDateTimeField source="validTill" />
                    <FormattedDateTimeField source="createdAt" />
                </Datagrid>
            </List>
        </div>
    );
};
export default OTPList;
